





























































import {Vue, Component, Prop, Watch, Ref} from 'vue-property-decorator';
import moment from 'moment';
import ConfirmButton from '@/components/ConfirmButton.vue';


@Component({
  components: {ConfirmButton},
})
export default class DatetimePicker extends Vue {
  @Prop({ default: null }) private datetime!: Date | string;
  @Prop({ default: '' }) private source!: string;
  @Prop({ default: true }) private isDisabled!: boolean;
  @Prop({ default: true }) private isUTC!: boolean;
  @Prop({ default: null }) private defaultDate!: Date | null;
  private activeTab: number = 0;
  private open: boolean = false;
  private date: string = '';
  private time: string = '';

  @Watch('datetime')
  private onDatetimeChange() {
    if (this.datetime) {
      this.date = this.parseDate(this.datetime).format('YYYY-MM-DD');
      this.time = this.parseDate(this.datetime).format('HH:mm:ss');
    } else if (this.defaultDate) {
      this.date = this.parseDate(this.defaultDate).format('YYYY-MM-DD');
      this.time = this.parseDate(this.defaultDate).format('HH:mm:ss');
    } else {
      this.date = this.parseDate().format('YYYY-MM-DD');
      this.time = this.parseDate().format('HH:mm:ss');
    }
  }

  private mounted() {
    if (this.datetime) {
      this.date = this.parseDate(this.datetime).format('YYYY-MM-DD');
      this.time = this.parseDate(this.datetime).format('HH:mm:ss');
      return; // Skip the event raising
    } else if (this.defaultDate) {
      this.date = this.parseDate(this.defaultDate).format('YYYY-MM-DD');
      this.time = this.parseDate(this.defaultDate).format('HH:mm:ss');
    } else {
      this.date = this.parseDate().format('YYYY-MM-DD');
      this.time = this.parseDate().format('HH:mm:ss');
    }
    // As we are setting defaults raise event
    this.applyDatetime();
  }

  private get label(): string {
    if (this.date && this.time) {
      const time = `${this.date}T${this.time}`;
      return `${this.parseDate(time).format('YYYY-MM-DD HH:mm')}${this.isUTC ? ' (UTC)' : ''}`;
    } else {
      return '';
    }
  }

  private applyDatetime() {
    this.$emit('update:datetime', this.parseDate(`${this.date}T${this.time}`).format());
  }

  private resetPicker() {
    this.open = false;
    this.activeTab = 0;
  }

  private showTimePicker() {
    this.activeTab = 1;
    this.applyDatetime();
  }

  get parseDate() {
    return this.isUTC ? moment.utc : moment;
  }
}
